/**
 *
 */
;(function(window, document, $) {
	$(function() {
		$('a')
			.filter(function() {
				return this.hostname && this.hostname !== document.location.hostname && this.hostname !== 'signon.springer.com';
			})
			.attr('target', '_blank')
			.each(function(index) {
				$(this).attr('onClick', "ga('send', 'event', 'Out-link', 'click', '" + $(this).attr('href') + "');");
			});

		$('a[href$=".pdf"]')
			.attr('target', '_blank')
			.filter(function() {
				return this.hostname && this.hostname == document.location.hostname;
			})
			.each(function(index) {
				$(this).attr('onClick', "ga('send', 'event', 'PDF', 'download', '" + $(this).attr('href') + "');");
			});
	});
})(window, document, window.jQuery);


// Links to subheadings on Klantenservice pages
;(function(window, document, $) {
	$(function() {
		// Add anchors to Klantenservice detail pages
		$('body.page-template-page_5 .content h2').each(function(index) {
			$(this).attr('id', 'sub-' + index.toString());
		});

		// Add links to Klantenservice start page
		$('body.page-template-page_4 .blocks-klantenservice h2').each(function(index) {
			var baseUrl = $(this).find('a').first().attr('href');

			var items = $(this).closest('div').find('li').each(function(index) {
				$(this).find('a').attr('href', baseUrl + '#sub-' + index.toString());
			});
		});
	});
})(window, document, window.jQuery);


;(function(window, document, $) {
	$(function() {
		/* Confirm */
		$(document).on('click', '.smbv-confirm', function(event) {
			var msg = $(this).data('confirm');

			if (msg === undefined) {
				msg = 'Weet u het zeker?';
			}

			return window.confirm(msg);
		});
	});
})(window, document, window.jQuery);
